/**
 * Static PNG intro shown once on hub first visit (`?isIntro=true`) before stage Rives.
 *
 * Belongs here: intro screen layout and Start CTA.
 * Does not belong here: stage animation logic (see useStageAnimations).
 */
import { PrimaryButton } from '../../../../../components/execution/PrimaryButton'
import { getBottomPadding } from '../../../../../utils/sessionStorage'
import { EventNames } from '../../../../../types/misc.types'
import { lightImpactVibrate, trackEvent } from '../../../../../utils/appBridge'
import { ExpertReviewEventIds, ExpertReviewScreen } from '../../analytics/expertReviewEvents'
import { expertReviewSafeAreaTopStyle } from '../../shared/expertReviewSafeArea'
import { ExpertReviewTopBar } from '../../shared/components/ExpertReviewTopBar'

interface StrategyQuestionnaireIntroProps {
  onBack: () => void
  onStart: () => void
}

/** Pre-flow intro before questions / entry Rive. */
export function StrategyQuestionnaireIntro({
  onBack,
  onStart
}: StrategyQuestionnaireIntroProps) {
  return (
    <div
      className='flex h-screen flex-col bg-white px-5'
      style={{
        ...expertReviewSafeAreaTopStyle(),
        paddingBottom: `calc(${getBottomPadding()}px + 24px)`
      }}
    >
      <div className='shrink-0'>
        <ExpertReviewTopBar
          onBack={onBack}
          analyticsScreen={ExpertReviewScreen.StrategyQuestionnaire}
          testLocatorBack='strategy-questionnaire-intro-back'
        />
      </div>
      <div className='flex flex-1 min-h-0 flex-col'>
        <div className='h-[8px]' />
        <div className='flex items-center flex-1 min-h-0 justify-center overflow-hidden pb-1'>
          <img
            src='/images/allocation/strategy-questionnaire-intro.png'
            alt=''
            className='max-w-full max-h-full w-auto min-h-[300px] object-contain'
            test-locator='strategy-questionnaire-intro-image'
          />
        </div>
        <div className='shrink-0'>
          <h1
            className='text-[24px] min-[400px]:text-[32px] font-[400] text-[#232323] leading-[120%]'
            test-locator='strategy-questionnaire-intro-title'
          >
            Find your ideal <br /> allocation strategy
          </h1>
          <p
            className='pt-4 pb-8 text-[14px] text-[#6A6E6E] leading-[140%]'
            test-locator='strategy-questionnaire-intro-description'
          >
            Answer questions on your life stage and risk appetite. This helps us decide how your portfolio should be allocated, so please take your time.
          </p>
          <PrimaryButton
            testLocator='strategy-questionnaire-intro-start'
            onClick={() => {
              lightImpactVibrate()
              trackEvent({
                eventName: EventNames.ButtonTap,
                payload: {
                  ScreenName: ExpertReviewScreen.StrategyQuestionnaire,
                  eventId: ExpertReviewEventIds.IntroStart,
                  buttonLabel: 'Start assessment'
                }
              })
              onStart()
            }}
            label='Start assessment'
            primaryButtonClassName='w-full !h-[56px] !font-[500] !rounded-[16px]'
          />
        </div>
      </div>
    </div>
  )
}
